import { convertKeys } from "./utils";
import { camelCase } from "change-case";

const rawConfig = convertKeys(globalThis.justwatch || {}, camelCase);

export default rawConfig;